module.exports = __webpack_public_path__ + "static/media/crud_perfil.cdb5a8c7.png";